var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeclinedPatients(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 560.82 581.23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #ee7404;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M352.7,296.02h-.01c-25.1,10.94-46.59,28.6-62.21,50.71-1.74,.06-3.5,.13-5.29,.2h-101.88c-110.96-4.66-128.57,22.03-124.48,146.85v87.45H0v-150.82c0-81.1,54.29-135.5,135.27-135.5h197.85c6.72,0,13.25,.37,19.58,1.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_3",
    "data-name": "Subtraction 3",
    className: "cls-1",
    d: "M235.06,267.92c-74.19-.04-134.29-60.22-134.25-134.4,.03-53.93,32.31-102.61,81.98-123.63,68.74-27.89,147.08,5.23,174.97,73.97,27.34,67.38-3.9,144.27-70.48,173.5-16.52,7-34.28,10.59-52.22,10.56Zm0-208.9c-41.2,0-74.61,33.4-74.61,74.61s33.4,74.61,74.61,74.61,74.61-33.4,74.61-74.61c-.04-41.19-33.42-74.56-74.61-74.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M412.06,283.71c-21.09,0-41.17,4.39-59.35,12.31h-.02c-25.1,10.94-46.59,28.6-62.21,50.71-17.12,24.23-27.18,53.81-27.18,85.74,0,81.33,65.26,147.41,146.28,148.74h.09c.79,.01,1.59,.02,2.39,.02,19.9,0,38.88-3.91,56.23-10.99,.03-.01,.06-.02,.09-.04,54.23-22.2,92.44-75.5,92.44-137.73,0-82.16-66.6-148.76-148.76-148.76Zm56.32,219.01s-.06,.05-.09,.07c-15.41,12.34-34.95,19.72-56.23,19.72-.8,0-1.6-.01-2.39-.04h-.09c-48.59-1.31-87.56-41.1-87.56-90,0-33.12,17.88-62.06,44.52-77.7,.01,0,.02,0,.03-.02,13.34-7.83,28.89-12.32,45.49-12.32,11.5,0,22.49,2.16,32.6,6.09,.04,.02,.09,.03,.13,.05,33.54,13.08,57.31,45.72,57.31,83.9,0,28.42-13.16,53.76-33.72,70.25Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 264.66,
    y: 417.79,
    width: 294.8,
    height: 29.36,
    transform: "translate(-185.11 418.04) rotate(-45)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeclinedPatients);
export default __webpack_public_path__ + "static/media/declinedPatients.035170f4c4eec1200dc6be4cbaeeda92.svg";
export { ForwardRef as ReactComponent };